import SearchResultsList from './SearchResultsList'

export default SearchResultsList
